import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button } from 'reactstrap'

export const UserCount = styled.div`
  color: ${themeGet('colors.backgroundBody')};
  display: flex;
`

export const UserCountPrefix = styled.span`
  font-weight: bold;
`

export const InviteAndRemindContainer = styled.div`
  align-items: end;
  background-color: ${themeGet('colors.white')};
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 1rem;
  padding-top: 1rem;
`

export const UserSummary = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 0.5rem;
`
export const ButtonsContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: row;
  margin-left: 0.5rem;
  min-height: 2.6875rem;
`
export const AddUserButton = styled(Button)`
  margin-left: 1rem;
`
export const UserGridStatusColContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
